import {getParentGroups} from "~/store/frontend/user/actions";
import {resendVerifyMailByAuthUserId} from '@/store/frontend/auth/actions';

const authResource = '/v1/auth';
const userResource = '/v1/user';
const userGroupResource = '/v1/user-group';

export default $axios => ({
  list(config) {
    return $axios.post(`${userResource}/list`, config);
  },

  getAllActiveUser(payload) {
    const query = new URLSearchParams(payload).toString();
    return $axios.get(`${userResource}/all-active-user?${query}`);
  },

  companies() {
    return $axios.get(`${userResource}/companies`);
  },

  getCompany(companyId) {
    return $axios.get(`/v1/company/${companyId}`);
  },

  verifyAccount(activeCode) {
    return $axios.get(`${authResource}/verify/${activeCode}`);
  },

  verifyEmailChangeEmail(token) {
    return $axios.post(`${authResource}/verify-email-change-email`, {token});
  },

  register(payload) {
    return $axios.post(`${authResource}/register`, payload);
  },

  login({email, password, deviceToken}) {
    return $axios.post(`${authResource}/login`, {email, password, deviceToken});
  },

  checkPassword({email, password, deviceToken}) {
    return $axios.post(`${authResource}/check-password`, {email, password, deviceToken});
  },

  info() {
    return $axios.get(`${authResource}/info`);
  },

  authUserInfo(token) {
    return $axios.get(`${authResource}/auth-user-info/${token}`);
  },

  logout() {
    return $axios.get(`${authResource}/logout`);
  },

  verifyEmail(payload) {
    return $axios.post(`${authResource}/verify-email`, payload);
  },

  resetPassword(payload) {
    return $axios.post(`${authResource}/forgot-password`, payload);
  },

  changePassword(payload) {
    return $axios.post(`${authResource}/change-password`, payload);
  },

  update(payload, config) {
    return $axios.post(`${userResource}/info`, payload, config);
  },

  updateNotification(payload) {
    return $axios.put(`${userResource}/notification`, payload);
  },

  invite(payload) {
    return $axios.post(`${userResource}/invite`, payload);
  },

  show(id) {
    return $axios.get(`${userResource}/${id}`);
  },

  delete(id) {
    return $axios.delete(`${userResource}/${id}`);
  },

  updateUserGroup(id, payload) {
    return $axios.put(`${userGroupResource}/${id}`, payload);
  },
  beforeUpdateUserGroup(id, payload) {
    return $axios.post(`v1/before-user-group/${id}`, payload);
  },
  getCategory() {
    return $axios.get('/v1/category');
  },

  getParentGroups() {
    return $axios.get('/v1/parentGroups');
  },
  getUserNotInvitedInGroup(payload) {
    return $axios.post('/v1/user-not-invited', payload);
  },
  getActivities(page) {
    return $axios.get(`/v1/activities?page=${page}`);
  },

  getDashBoardNotifications(page) {
    return $axios.get(`/v1/notifications/dashboard?page=${page}`);
  },

  getBellNotifications(time) {
    return $axios.get(`/v1/notifications/bell?time=${time}`);
  },

  fetchBellNotifications(time) {
    return $axios.get(`/v1/notifications/fetchBell?time=${time}`);
  },

  readNotification(id) {
    return $axios.put('/v1/notifications/read', {id});
  },

  updateUserFirstTimeByToken(token, payload) {
    return $axios.put(`${authResource}/update-user-info-first-time/${token}`, payload);
  },

  resendVerifyMail(payload) {
    return $axios.post(`${authResource}/resend-verify-email`, payload)
  },

  checkCanVerifyEmail(token) {
    return $axios.post(`${authResource}/check-can-verify-email`, {token});
  },

  updateFirstLoggedIn() {
    return $axios.put(`${authResource}/update-first-logged-in`)
  },

  sendMailExpiredPlan() {
    return $axios.post(`/v1/send-mail-noty-expired`)
  },

  resendVerifyMailByAuthId({token}) {
    return $axios.get(`${authResource}/resend-verify-email-by-auth-id/${token}`)
  },

  getInvalidGroup(payload) {
    return $axios.post(`v1/get-invalid-group/${payload.userId}`, payload);
  },

  syncCalendarForCompany() {
    return $axios.post(`v1/sync-company-calendar`)
  }
});
